import { Grid, Typography } from '@material-ui/core'
import ErrorIcon from '@material-ui/icons/Error'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import { paymentErrorMessage } from '../../../lib/m2/errors'

const StyledErrorIcon = styled(ErrorIcon)`
  // Using margins here to ensure this icon matches the spacing/layout of the CreditCardTypeIcon
  // despite the difference in shape and size:
  margin-left: 15px;
  margin-right: 15px;
`

export interface PaymentDeclinedMessageProps {
  className?: string
  error?: string
}

const PaymentDeclinedMessage: React.FC<PaymentDeclinedMessageProps> = ({ className, error }) => {
  const displayErrorRef: React.RefCallback<HTMLDivElement> = useCallback((errorRef) => {
    if (errorRef) {
      errorRef.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  if (!error) {
    return null
  }

  return (
    <Grid
      className={className}
      container
      item
      xs={12}
      wrap="nowrap"
      data-cy="payment-decline-message"
      ref={displayErrorRef}
    >
      <Grid item>
        <StyledErrorIcon color="error" fontSize="small" />
      </Grid>
      <Grid item>
        <Typography variant="caption" color="error" gutterBottom>
          {paymentErrorMessage(error)}
        </Typography>
      </Grid>
    </Grid>
  )
}

const StyledPaymentDeclinedMessage = styled(PaymentDeclinedMessage)`
  margin-bottom: 15px;
`

export default StyledPaymentDeclinedMessage
